import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    grade_level: '',
    student: '',
  },
}

export const earlyWarningsUI = createSlice({
  name: 'earlyWarningsUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setGradeLevel: (state, { payload }) => {
      state.tableFilters.grade_level = payload
    },
    setStudent: (state, { payload }) => {
      state.tableFilters.student = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setGradeLevel,
  setStudent,
  trackActiveFilters,
  clearAllFilters,
} = earlyWarningsUI.actions

export default earlyWarningsUI.reducer
